module.exports = __webpack_public_path__ + "static/img/u916.c3705a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u916.png
// module id = B6Ey
// module chunks = 209